// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 此处后端没有提供注释 GET /api/filter */
export async function filterControllerGetList(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.FilterControllerGetListParams,
	options?: { [key: string]: any }
) {
	return request<API.PaginatedDto & { results?: API.FilterListResponse[] }>(
		'/api/filter',
		{
			method: 'GET',
			params: {
				// page has a default value: 1
				page: '1',
				// size has a default value: 10
				size: '10',

				...params,
			},
			...(options || {}),
		}
	);
}

/** 此处后端没有提供注释 PUT /api/filter */
export async function filterControllerUpdate(
	body: API.FilterUpdateRequest,
	options?: { [key: string]: any }
) {
	return request<boolean>('/api/filter', {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
		},
		data: body,
		...(options || {}),
	});
}

/** 此处后端没有提供注释 POST /api/filter */
export async function filterControllerCreate(
	body: API.FilterCreateRequest,
	options?: { [key: string]: any }
) {
	return request<boolean>('/api/filter', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		data: body,
		...(options || {}),
	});
}

/** 此处后端没有提供注释 GET /api/filter/${param0} */
export async function filterControllerGet(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.FilterControllerGetParams,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<API.FilterViewResponse>(`/api/filter/${param0}`, {
		method: 'GET',
		params: { ...queryParams },
		...(options || {}),
	});
}

/** 此处后端没有提供注释 DELETE /api/filter/${param0} */
export async function filterControllerRemove(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.FilterControllerRemoveParams,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<boolean>(`/api/filter/${param0}`, {
		method: 'DELETE',
		params: { ...queryParams },
		...(options || {}),
	});
}
